export default "__VITE_ASSET__lymX5ypX__"